import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '../../app/guards'
import { AccountsPage } from '../../features/accounting/accounts-page'

export const Route = createFileRoute('/_app/accounts')({
  staticData: { crumb: 'accounts' },
  beforeLoad: ({ context }) => requirePermission(context.session, 'ledger.read'),
  component: AccountsPage,
})
